// main.ts
import Vue from 'vue'

import App from './App.vue'
import commonMethods from '@/nms/plugins/commonMethods.ts'
import fileMethods from '@/nms/plugins/fileMethods.ts'

import VueI18n from 'vue-i18n'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import { Ripple } from 'vuetify/es5/directives'

import en from 'vuetify/es5/locale/en'
import ru from 'vuetify/es5/locale/ru'
import es from 'vuetify/es5/locale/es'

import '@mdi/font/css/materialdesignicons.css'

import AsyncComputed from 'vue-async-computed'

import Snotify from 'vue-snotify'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'

import TreeView from 'vue-json-tree-view'

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios'
import VueWorker from 'vue-worker'

import merge from 'deepmerge'

import $errorHandler from '@/nms/components/utils/error-handler.ts'
// import $errorHandler from '@/nms/components/utils/error-handler.js'

import $_uid from '@/nms/components/utils/uid.ts'
// import $_uid from '@/nms/components/utils/uid.js'
import {
  initBridge,
  getURL,
  isDevMode,
  $_localhost,
} from '@/nms/plugins/bridge.js'
import router from '@/nms/router'
import store, { RootState } from '@/nms/store'

import LocalServiceWorkerRegister from '@/nms/components/utils/push-notifications/SWRegister.js'

// Типы
interface UserResponse {
  role: string
  level?: number
  subsystem?: string
  [key: string]: any
}

interface DictionaryData {
  [key: string]: any
}

interface KeycloakData {
  [key: string]: any
}

interface RouteQuery {
  initApp?: string
  kiosk?: string
  code?: string
  login?: string
  password?: string
  objectId?: string
}

// Регистрация Service Worker
LocalServiceWorkerRegister()

// Импорт стилей
import '../node_modules/material-design-icons-iconfont/dist/material-design-icons.css'
import '@/nms/assets/styles/styles.styl'

// Регистрация плагинов
Vue.use(commonMethods, { store })
Vue.use(fileMethods, { store })
Vue.use(VueWorker)
Vue.use(VueI18n)
Vue.use(TreeView)
Vue.use(Vuetify, {
  iconfont: 'mdi',
  lang: {
    locales: { en, ru, es },
    current: 'ru',
  },
  directives: {
    Ripple,
  },
  theme: {
    back: '#ffffff',
    black: '#1A1A1A',
    blackLine: '#221F20',
    blacktext: '#4B4B4B',
    secondary: '#7F7F7F',
    primary: '#025EA1',
    line: '#4daaf1',
    accent: '#6CACE4',
    active: '#D4EEFC',
    error: '#EC1C24',
    warning: '#F0A600',
    damage: '#EE6C23',
    success: '#259789',
    ok: '#B2C541',
    grey: '#E1E1E1',
    backgrey: '#EBEBEB',
    lightgrey: '#9F9F9F',
    out: '#F1F1F2',
    particles: '#1f1f1f',
    graph: '#F0F6FA',
  },
})
Vue.use(AsyncComputed)
Vue.use(Snotify)
Vue.use(VuetifyDialog, {
  store,
  confirm: {
    actions: {
      false: 'No',
      true: {
        text: 'Yes',
        color: 'primary',
      },
    },
    icon: false,
    width: 500,
  },
  warning: {},
  error: {},
  prompt: {},
})

require('vue-snotify/styles/material.css')

Vue.use(VueMoment, {
  moment,
})

// Глобальные свойства Vue
Vue.prototype.moment = moment
Vue.prototype.$localhost = $_localhost

const baseURL = getURL('bridge')
const scripterURL = getURL('bridge')

Vue.prototype.$baseURL = baseURL
Vue.prototype.$scripterURL = scripterURL

// Создание экземпляра axios
const $_instanceAxios: AxiosInstance = axios.create({
  baseURL,
})

$_instanceAxios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      console.log('Axios', 'intercepts', '401')
      router.push('/')
    }
    return Promise.reject(error)
  },
)

Vue.prototype.$http = $_instanceAxios

const mapsURL = getURL('maps')
Vue.prototype.$mapsURL = mapsURL
Vue.prototype.$merge = merge
Vue.prototype.$uid = $_uid
Vue.prototype.$errorHandler = $errorHandler

Vue.config.productionTip = false

// Вспомогательные функции
const setLoggedParams = async (resp: UserResponse, user: any) => {
  try {
    store.dispatch('setLogged', true)
    store.dispatch('checkForLogged')
    const access: Record<string, number> = {
      administrator: 0,
      manager: 1,
      operator: 2,
      inform_secur_user: 3,
    }
    resp.level = access[resp.role]
    resp.subsystem = 'common'
    const setedUser = await store.dispatch('setLoggedUser', resp)
    return setedUser
  } catch (err) {
    $errorHandler(err)
    console.log(err)
    router.push({ name: 'login' })
  }
}

const extControlHandler = async (to: any, from: any, next: any) => {
  console.log('extControlHandler to', to)
  
  if (!store.getters.getUILoaded) {
    const params = {}
    await store.dispatch('loadLicense', params)
  }
  
  if (!store.getters.isLogged && to.query?.login && to.query?.password) {
    console.log('extControlHandler !isLogged', 'login ', to.query.login, 'password ', to.query.password)
    const l = await store.dispatch('login', { user: to.query.login, password: to.query.password })
    console.log('extControlHandler !isLogged', l)
    await setLoggedParams(l, { login: to.query.login })
  }
  
  if (!store.getters.isLogged && to.query?.code) {
    console.log('extControlHandler !isLogged', 'to ', to)
    console.log('extControlHandler !isLogged', 'code ', to.query.code)
    const user = { subsystem: 'common' }
    const l = await store.dispatch('KCLogin', { code: to.query.code, user })
    console.log('extControlHandler !isLogged KCLogin', l)
    await setLoggedParams(l, user)
    
    const pages = store.getters.getPages
    await store.dispatch('pageChange', pages[0])
    router.push({ name: pages[0], params: { to, from } })
  }
  
  const id = to.query?.objectId
  const cls = id?.split('$')[0]
  const mode = to.query?.kiosk === 'true' || to.query?.kiosk === true
  const name = to.name
  
  store.commit('KIOSK', mode)
  
  if (mode && id && cls) {
    const obj = await store.dispatch('activeTreeObj', id)
    store.commit('PAGE_CHANGE', name)
    
    if (cls === 'location') {
      await store.dispatch('activeSidebar', cls)
      await store.dispatch('activeCabinet', null)
      router.push({ name: 'topology_location', params: { to, from } })
    }
    if (cls === 'cabinet') {
      await store.dispatch('activeSidebar', cls)
      store.dispatch('activeDevice', null)
      router.push({ name: 'topology_cabinet', params: { to, from } })
    }
    if (cls === 'device' || cls === 'module') {
      try {
        await store.dispatch('activeSidebar', cls)
        router.push({ name: 'topology_device', params: { to, from } })
        return
      } catch (error) {
        console.log('extControlHandler', 'error', error)
      }
    }
  }
  next()
}

// Роутер guards
router.beforeResolve(async (to: any, from: any, next: any) => {
  console.log('MAIN.JS ROUTER', 'from', from)
  console.log('MAIN.JS ROUTER', 'to', to)
  
  if (to.query?.initApp && to.query?.initApp === 'false') {
    console.log('MAIN.JS ROUTER initApp FALSE')
    return
  }
  
  if (to.query?.kiosk) {
    extControlHandler(to, from, next)
    return
  }
  
  if (to.query?.code) {
    await extControlHandler(to, from, next)
    return
  }
  
  if (!store.getters.getUILoaded) {
    const params = {}
    await store.dispatch('loadLicense', params)
  }
  
  if (!store.getters.isLogged && to.name !== 'login') {
    console.log('BEFORESOLVE to', to)
    next({ name: 'login', params: { to, from } })
  } else {
    next()
  }
})

// Инициализация приложения
let dictionary: DictionaryData = {}
let keycloak: KeycloakData = {}

const i18nURL = getURL('i18n')

$_instanceAxios
  .get(i18nURL)
  .then((d: AxiosResponse) => {
    const urlParams = new URLSearchParams(window.location.search)
    const initAppParam = urlParams.get('initApp')
    
    if (initAppParam && initAppParam === 'false') {
      console.log('initApp', initAppParam)
      return
    }
    
    if (d) {
      console.log('load i18n dictionary success')
      dictionary = d.data
      appInit()
    } else {
      console.log('load i18n dictionary false')
      appInit()
    }
  })
  .catch((err: Error) => {
    console.log('load i18n dictionary error', err)
    alert('something wrong with connection server')
    appInit()
  })

const appInit = () => {
  initBridge().then(($_bridge: any) => {
    Vue.prototype.$bridge = $_bridge
    
    $_bridge
      .customQuery('alarm', 'auth/KCInfo', {}, 'get')
      .then((kc: KeycloakData) => {
        if (kc) {
          keycloak = kc
          Vue.prototype.$keycloak = keycloak
        } else {
          console.log('$auth/KCInfo smth wrong', kc)
        }
      })
    
    const i18n = new VueI18n({
      locale: 'ru',
      messages: dictionary,
      silentTranslationWarn: true,
    })
    
    new Vue({
      el: '#app',
      i18n,
      router,
      store,
      components: { App },
      template: '<App/>',
    })
  })
}